
import { Link } from 'react-router'

import { cn } from '@shared/lib/cn'
import ImageWithBg from '@shared/ui/image-with-bg'

import styles from './styles.module.scss'

export interface MenuItem {
  id: string;
  label: string;
  icon: string;
  iconBgColor: string;
  href?: string;
  onClick?: () => void;
}

interface ScrollableMenuProps {
  className?: string;
  items: MenuItem[];
}

export default function ScrollableMenu ({ className, items }: ScrollableMenuProps) {
  const handleItemClick = (item: MenuItem) => {
    if (item.onClick) {
      item.onClick()
    }
  }

  return (
    <div className={cn(styles.scrollableMenu, className)}>
      <div className={styles.scrollableMenu__scrollerContainer}>
        <div className={styles.scrollableMenu__container}>
          {items.map((item) => (
            <Link
              key={item.id}
              to={item.href ?? ''}
              className={styles.scrollableMenu__item}
              onClick={() => handleItemClick(item)}
            >
              {item.icon && (
                <div
                  className={styles.scrollableMenu__icon}
                  style={{ backgroundColor: item.iconBgColor }}
                >
                  <ImageWithBg
                    src={item.icon}
                    className={styles.scrollableMenu__iconImage}
                  />
                </div>
              )}
              <span className={styles.scrollableMenu__label}>
                {item.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
